import BaseModel from "./BaseModel";

/**
 * Default Response object
 */
export default class Response extends BaseModel{
    definedCodes = {
        API_SUCCESS: 200,
        UNAUTHENTICATED: 401,
        SERVER_ERROR: 500,
        API_ERROR: 900
    }

    constructor(requestResult = {}) {
        super();
        
        this.statusCode = requestResult.status != undefined ? requestResult.status : this.definedCodes.SERVER_ERROR;
        this.resMessage = requestResult.resMessage != undefined ? requestResult.resMessage : '';
        this.contentVal = requestResult.data != undefined ? requestResult.data : null;
        this.headersBag = requestResult.headers != undefined ? requestResult.headers : {};
    }

    /**
     * Get code
     * @returns {Integer} 
     */
    getCode() {
        return this.statusCode;
    }

    /**
     * Get message
     * @returns {String}
     */
    getMessage() {
        return this.resMessage;
    }

    /**
     * Get content
     * @returns {*}
     */
    getContent() {
        return this.contentVal;
    }

    /**
     * Get headers
     * @returns {Object}
     */
    getHeaders() {
        return this.headersBag;
    }

    /**
     * Tries to get header value
     * @param {String} name 
     * @returns any|null
     */
    getHeader(name = '') {
        return this.getHeaders()[name] != undefined ? this.getHeaders()[name] : null;
    }

    /**
     * Checks if code is the defined API_SUCCESS
     * @returns {Boolean}
     */
    success() {
        return this.getCode() == this.definedCodes.API_SUCCESS ? true : false;
    }

    /**
     * Checks if code is the defined API_ERROR
     * @returns {Boolean}
     */
    apiError() {
        return this.getCode() == this.definedCodes.API_ERROR ? true : false;
    }

    /**
     * Checks if code is the defined UNAUTHENTICATED
     * @returns 
     */
    notAuthenticated() {
        return this.getCode() == this.definedCodes.UNAUTHENTICATED ? true : false;
    }

    /**
     * Sets the content of the response
     * @param {any} values
     */
    setContent(values) {
        this.contentVal = values;
    }
}